import List from '../../pages/Blog/Articles/List';
import Detail from '../../pages/Blog/Articles/Detail';
import Create from '../../pages/Blog/Articles/Create';

export const subRoutesArticles = [
    {
        path: "",
        component: List,
        exact: true,
    }
].map((item) => {
    return {
        ...item,
        path: `/articles${item.path}`,
        private: true
    };
});

export const routesArticles = [
    {
        path: "/create",
        component: Create,
        exact: true
    },
    {
        path: "/:elementId",
        component: Detail,
    }
].map((item) => {
    return {
        ...item,
        path: `/articles${item.path}`,
        private: true
    };
});